module.exports = __webpack_public_path__ + "static/media/insurance-card.e6368774.png";